import { array, string, object, oneOfType } from 'prop-types'
import React, { Component } from 'react'
import Form from '../Form'
import { TrackedScrollableMenu } from '../ScrollableMenu'
import { kuiperClassNames } from '../utils'

const FORM_CLASS_NAME = 'msf-form'
class MultiStepForm extends Component {
  static propTypes = {
    // when only one child is present it is teated as an object
    // because MenuSection is rendered with fragments
    children: oneOfType([array, object]),
    className: string,
    secondaryTitle: object,
    title: string,
  }

  get otherProps() {
    // eslint-disable-next-line no-unused-vars
    const { children, title, ...otherProps } = this.props

    return otherProps
  }

  renderForm = (children, customClassName, menuProps) => (
    <Form
      {...this.otherProps}
      {...menuProps}
      customClass={kuiperClassNames(FORM_CLASS_NAME, customClassName)}
    >
      {children}
    </Form>
  )

  render() {
    return (
      <div
        className={kuiperClassNames('multi-step-form', this.props.className)}
      >
        <TrackedScrollableMenu
          menuSections={React.Children.toArray(this.props.children)}
          previewArea={this.renderForm}
          secondaryTitle={this.props.secondaryTitle}
          title={this.props.title}
        />
      </div>
    )
  }
}

export default MultiStepForm
